<div
  class="tw-absolute tw-bottom-5 tw-z-50 tw-left-0 tw-right-0 tw-flex tw-justify-center tw-w-full"
  id="batch-operations-container"
  [shown]="
    listStateService.getSelected().length > 0 && hasAvailableOperations()
  "
>
  <div
    class="tw-flex tw-items-center tw-gap-2.5 tw-py-[5px] tw-px-2.5 tw-bg-gray-800 tw-text-white tw-rounded-full tw-w-[95%] xl:!tw-w-[725px] {{
      styles
    }}"
  >
    <button
      mat-icon-button
      aria-label="Close"
      class="hover:tw-bg-gray-700"
      (click)="listStateService.deselectAll()"
    >
      <mat-icon svgIcon="close" />
    </button>

    <span class="tw-text-[15px] tw-text-slate-400"
      >{{ listStateService.getSelected().length }} Selected</span
    >

    <button
      mat-button
      class="!tw-text-rise-green-500 tw-text-[15px] hover:tw-bg-gray-700"
      (click)="toggleSelectAll()"
    >
      {{ listStateService.isAllSelected() ? 'Select None' : 'Select All' }}
    </button>

    <div class="tw-flex-grow"></div>

    @for (operation of filteredMainBarOperations; track operation) {
      <button
        mat-button
        *requireRole="operation.requireRole"
        [attr.aria-label]="operation.name"
        class="!tw-text-white !tw-fill-white hidden xl:!tw-flex hover:tw-bg-gray-700"
        [id]="'action' + operation.name.split(' ').join('')"
        [ngClass]="{ 'rise-admin-only': operation.requireRole === 'sa' }"
        (click)="executeOperation(operation)"
      >
        <mat-icon
          class="!tw-scale-100"
          [svgIcon]="operation.icon || getOperationIcon(operation.name)"
        />
        <span class="tw-ml-[5px] tw-font-normal">{{ operation.name }}</span>
        @if (getUpgradeIcon(operation); as upgradeIcon) {
          <mat-icon class="small tw-ml-[5px]" [svgIcon]="upgradeIcon" />
        }
      </button>
      <div
        class="tw-w-[1px] tw-bg-gray-600 tw-h-[25px] hidden xl:!tw-block"
        *ngIf="!$last"
      ></div>
    }

    @if (hasBulkDropdownContent) {
      <button
        mat-icon-button
        aria-label="More actions"
        class="hover:tw-bg-gray-700 tw-hidden xl:!tw-block tw-pt-[5px]"
        [matMenuTriggerFor]="moreMenu"
        id="more-actions-button"
      >
        <mat-icon svgIcon="more-vertical" />
      </button>
      <button
        mat-icon-button
        aria-label="More actions"
        class="hover:tw-bg-gray-700 xl:!tw-hidden"
        [matMenuTriggerFor]="moreMenu"
        id="more-actions-button-mobile"
      >
        <mat-icon svgIcon="more-vertical" />
      </button>
    }
  </div>
</div>

<mat-menu
  #remoteCommandsMenu="matMenu"
  class="batch-actions-menu tw-bg-gray-800 tw-rounded-[7.5px] tw-min-w-[300px]"
>
  @for (child of remoteCommandsMenuChildren; track $index) {
    @if (child.separator) {
      <mat-divider class="tw-bg-slate-700 !tw-my-[5px]"></mat-divider>
    } @else {
      <span
        class="tw-block tw-w-full"
        matTooltip="Coming soon"
        [matTooltipDisabled]="!child.uiOnly"
      >
        <button
          mat-menu-item
          type="button"
          [attr.aria-label]="child.name"
          class="tw-text-white hover:!tw-bg-gray-700 tw-px-[15px]"
          [ngClass]="{
            'rise-admin-only': child.requireRole === 'sa',
            '!tw-opacity-50': child.uiOnly,
            'tw-pointer-events-none': child.uiOnly,
            '!tw-cursor-pointer': !child.uiOnly,
          }"
          [disabled]="child.uiOnly"
          [id]="'action' + child.name.split(' ').join('')"
          (click)="!child.uiOnly && executeOperation(child)"
        >
          <mat-icon
            [class]="bulkMenuIconClass"
            [svgIcon]="getOperationIcon(child.name)"
          />
          {{ child.name }}
        </button>
      </span>
    }
  }
</mat-menu>

<mat-menu
  #moreMenu="matMenu"
  class="batch-actions-menu tw-bg-gray-800 tw-rounded-[7.5px] tw-min-w-[300px]"
>
  <div class="tw-text-white tw-text-[15px] tw-py-[5px] tw-px-[15px]">
    Actions
  </div>

  @let rcOp = remoteCommandsBulkOperation();
  @if (rcOp) {
    <button
      mat-menu-item
      *requireRole="rcOp.requireRole"
      type="button"
      [attr.aria-label]="rcOp.name"
      class="!tw-flex tw-items-center tw-text-white hover:!tw-bg-gray-700 tw-px-[15px]"
      [ngClass]="{ 'rise-admin-only': rcOp.requireRole === 'sa' }"
      [matMenuTriggerFor]="remoteCommandsMenu"
      [id]="'action' + rcOp.name.split(' ').join('')"
    >
      <mat-icon
        [class]="bulkMenuIconClassLeading"
        [svgIcon]="getOperationIcon(rcOp.name)"
      />
      <span class="tw-flex-1 tw-text-left">{{ rcOp.name }}</span>
    </button>
  }

  @if (rcOp && filteredMainBarOperations.length > 0) {
    <mat-divider
      class="tw-bg-slate-700 !tw-my-[5px] xl:!tw-hidden"
    ></mat-divider>
  }

  @for (operation of filteredMainBarOperations; track operation) {
    <button
      mat-menu-item
      *requireRole="operation.requireRole"
      type="button"
      [attr.aria-label]="operation.name"
      class="tw-text-white xl:!tw-hidden hover:!tw-bg-gray-700 tw-px-[15px]"
      [ngClass]="{ 'rise-admin-only': operation.requireRole === 'sa' }"
      [id]="'action' + operation.name.split(' ').join('') + 'Mobile'"
      (click)="executeOperation(operation)"
    >
      <mat-icon
        [class]="bulkMenuIconClass"
        [svgIcon]="operation.icon || getOperationIcon(operation.name)"
      />
      {{ operation.name }}
      @if (getUpgradeIcon(operation); as upgradeIcon) {
        <mat-icon class="small tw-ml-2" [svgIcon]="upgradeIcon" />
      }
    </button>
  }

  @if (
    filteredAdditionalOperations.length > 0 &&
    (rcOp || filteredMainBarOperations.length > 0)
  ) {
    <mat-divider class="tw-bg-slate-700 !tw-my-[5px]"></mat-divider>
  }

  @for (operation of filteredAdditionalOperations; track operation) {
    @if (operation.separator) {
      <mat-divider class="tw-bg-slate-700 !tw-my-[5px]"></mat-divider>
    } @else {
      <button
        mat-menu-item
        *requireRole="operation.requireRole"
        type="button"
        [attr.aria-label]="operation.name"
        class="tw-text-white hover:!tw-bg-gray-700 tw-px-[15px]"
        [ngClass]="{ 'rise-admin-only': operation.requireRole === 'sa' }"
        [id]="'action' + operation.name.split(' ').join('')"
        (click)="executeOperation(operation)"
      >
        <mat-icon
          [class]="bulkMenuIconClass"
          [svgIcon]="operation.icon || getOperationIcon(operation.name)"
        />
        {{ operation.name }}
        @if (getUpgradeIcon(operation); as upgradeIcon) {
          <mat-icon class="small tw-ml-2" [svgIcon]="upgradeIcon" />
        }
      </button>
    }
  }
</mat-menu>

<div
  id="batchOperationsProgress"
  class="border-container text-center u_padding-20"
  [shown]="listService.activeOperation"
>
  <div class="multi-actions-progress-panel">
    <p class="mb-0">
      <strong
        >Bulk {{ listService.activeOperation?.name | lowercase }} in
        progress.</strong
      >&nbsp;<a rv-link appearance="inline" (click)="batchService.cancel()"
        >Cancel</a
      >
    </p>
    <p>Please don't navigate away from this page.</p>
    <div class="progress my-4">
      <div
        class="progress-bar"
        role="progressbar"
        attr.aria-valuenow="{{ batchService.listOperations.progress }}.0"
        attr.aria-valuemin="0"
        attr.aria-valuemax="100"
        [style.width]="batchService.listOperations.progress + '%'"
      ></div>
    </div>
    <p class="mb-0">
      {{ batchService.listOperations.completedItemCount }} out of
      {{ batchService.listOperations.totalItemCount }}
      operations completed.
      <!--
      {{batchService.listOperations.name | lowercase}}<span [shown]="batchService.listOperations.totalItemCount > 1">s</span>
      {{listObject?.batchOperations.activeOperation.name | lowercase}}d.
      -->
    </p>
  </div>
</div>
